// extracted by mini-css-extract-plugin
export default {"copy":"style_copy__2uUHv"};